import { APP_ENV, BACKEND_ENV, ENV_NAMES } from "@utils/utils";
import React from "react";

import { Small } from "@fronterahealth/frontera-ui-components";

const envMarkerMap: Partial<Record<ENV_NAMES, { label: string; style: string }>> = {
  [ENV_NAMES.LOCAL]: { label: "Local", style: "bg-hatch-50 border-hatch-200" },
  [ENV_NAMES.DEV]: { label: "Dev", style: "bg-hatch-50 border-hatch-200" },
  [ENV_NAMES.STAGING]: { label: "Staging", style: "bg-amber-50 border-amber-200" },
  [ENV_NAMES.PROD]: { label: "Production", style: "bg-globemallow-50 border-globemallow-200" },
};

export const EnvironmentMarker: React.FC = () => {
  const frontendMarker = envMarkerMap[APP_ENV];
  const backendMarker = envMarkerMap[BACKEND_ENV];
  const environmentsMatch = APP_ENV === BACKEND_ENV;

  return (
    <div className={`flex flex-col px-4 my-4 py-2 border rounded-md w-full ${backendMarker?.style}`}>
      {environmentsMatch ? (
        <div className="flex flex-row">
          <Small className="mr-1" colorType="primary">
            Environment:
          </Small>
          <Small displayType="loud" colorType="primary">
            {backendMarker?.label}
          </Small>
        </div>
      ) : (
        <>
          <div className="flex flex-row">
            <Small className="mr-1" colorType="primary">
              Frontend:
            </Small>
            <Small displayType="loud" colorType="primary">
              {frontendMarker?.label}
            </Small>
          </div>
          <div className="flex flex-row">
            <Small className="mr-1" colorType="primary">
              Backend:
            </Small>
            <Small displayType="loud" colorType="primary">
              {backendMarker?.label}
            </Small>
          </div>
        </>
      )}
    </div>
  );
};
